export default __webpack_public_path__ + "static/media/accounting-bot_vn.794b04a7.png";